import { render, staticRenderFns } from "./SetupDone.vue?vue&type=template&id=7dba2349&"
import script from "./SetupDone.vue?vue&type=script&lang=js&"
export * from "./SetupDone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports